import { AboutApp } from '../../components/AboutApp';
import { AccountTypes } from '../../components/AccountTypes';
import { AppPromo } from '../../components/AppPromo';
import { EditorialMedia } from '../../components/EditorialMedia';
import { FAQ } from '../../components/FAQ';
import { Hero } from '../../components/Hero';
import { HuddInMedia } from '../../components/HuddInMedia';
import { Reviews } from '../../components/Reviews';
import { SimpleDashboard } from '../../components/SimpleDashboard';
import { Statistics } from '../../components/Statistics';
import { WordsMarquee } from '../../components/WordsMarquee';

const HomePage = () => {
  return (
    <>
      <Hero />
      <AppPromo />
      <Statistics />
      <AccountTypes />
      <AboutApp />
      <SimpleDashboard />
      <HuddInMedia />
      <FAQ />
      <EditorialMedia />
      <Reviews />
      <WordsMarquee />
    </>
  );
};

export default HomePage;
